import { DateTime } from 'luxon';

import {
  getLongTermContractAttributes,
  ILongContractAttributes,
} from '@pharmaplan/common';

import { toStandardFormat } from '../../helpers/Functions';
import { useAppSelector } from '../useAppSelector';

const fallbackDate = new Date();

const useGetChangedContract = () => {
  const longTermAttributes = useAppSelector(getLongTermContractAttributes);
  const {
    defaultEndTime,
    defaultStartTime,
    startDate,
    endDate,
    shiftContractAttributes,
  } = longTermAttributes ?? {};

  const comparator = () => {
    const { hour: sHour, minute: sMinute } = DateTime.fromJSDate(
      (defaultStartTime as Date) ?? fallbackDate,
    );

    const { hour: eHour, minute: eMinute } = DateTime.fromJSDate(
      (defaultEndTime as Date) ?? fallbackDate,
    );

    return {
      startDate: toStandardFormat(
        startDate?.set({
          hour: sHour,
          minute: sMinute,
          second: 0,
        }),
      ),
      endDate: toStandardFormat(
        endDate?.set({
          hour: eHour,
          minute: eMinute,
          second: 0,
        }),
      ),
    };
  };

  const getTimeOnly = (dateString: string) =>
    dateString?.split?.('T')?.[1] ?? '';

  const getChangedItems = () =>
    shiftContractAttributes?.filter(
      (item) =>
        !(
          getTimeOnly(item.startDate) === getTimeOnly(comparator().startDate)
          && getTimeOnly(item.endDate) === getTimeOnly(comparator().endDate)
        ) || item.dayOff,
    );

  const getChangedItemsFromParams = (
    attributes: Array<ILongContractAttributes>,
    compareStart: string,
    compareEnd: string,
  ) =>
    attributes?.filter(
      (item) =>
        !(
          getTimeOnly(item.startDate) === getTimeOnly(compareStart)
          && getTimeOnly(item.endDate) === getTimeOnly(compareEnd)
        ),
    );

  return { getChangedItems, comparator, getChangedItemsFromParams };
};

export default useGetChangedContract;
